import script from "./AdminFormElementTextarea.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminFormElementTextarea.vue?vue&type=script&setup=true&lang=js"

import "./AdminFormElementTextarea.vue?vue&type=style&index=0&id=a340f490&lang=scss"

const __exports__ = script;

export default __exports__